import { BaseEntity } from "./system";

export interface IShippingPolicy extends BaseEntity {
  name: string;
  price: number;

  daysToDeliver: number;
  handlingTime: number; // Hours
  policyId: string; // External system ID
  courier?: string;

  source: ShippingPolicySource;
  shippingProviderId?: string;
  // Mirrors eBay's "Exclude shipping locations → Northern Ireland"; synced to PartPro
  excludeNorthernIreland: boolean;
}

export enum ShippingPolicySource
{
  Internal,
  External, // Generic source from somewhere else
  Ebay
}

export interface ShippingPolicyCreateRequest extends Omit<IShippingPolicy, "id" | "created" | "updated" | "source"> {}